import SignupBeneConfirm from './container'

export default SignupBeneConfirm
